export const ALLOWED_NEWS_IMAGE_TYPES = 'jpeg,png,webp,svg+xml';
